import Layout from '@/pages/frame';
import accommodationManagement from '@/pages/accommodationManagement/accommodationManagement.vue';
import accommodationArrangement from '@/pages/accommodationManagement/accommodationArrangement.vue';
import accommodationQuery from '@/pages/accommodationManagement/accommodationQuery.vue';
export default {
	path: '/zsgl',
	menuName: '住宿管理',
	component: Layout,
	children: [{
		path: 'index',
		menuName: '住宿情况统计',		
		// component: require('@/pages/home/index'),
		component: accommodationManagement,//住宿情况统计
	},{
		path: 'Arrangement',
		menuName: '学生住宿安排',		
		// component: require('@/pages/home/index'),
		component: accommodationArrangement,//学生住宿安排
	},{
		path: 'Query',
		menuName: '学生住宿查询',
		
		// component: require('@/pages/home/index'),
		component: accommodationQuery,//学生住宿查询
	}],
	 component: (resolve) => require(['@/pages/accommodationManagement/index.vue'], resolve)
}


// WEBPACK FOOTER //
// ./src/routes/modules/accommodationManagement.js